import type { PageThemeDefinition } from "../types";

export const emeraldTheme: PageThemeDefinition = {
  id: "emerald",
  labelKey: "robot.setting.page_theme.emerald",
  preview: {
    background: "#0A1A12",
    cardBg: "#0F2419",
    text: "#ffffff",
  },
  tokens: {
    background: "#0A1A12",
    cardBg: "#0F2419",
    text: "#ffffff",
    textSecondary: "#A8D5B8",
    border: "#1A4A32",
    headerBg: "#0A1A12",
    inputBg: "#0F2419",
    messageBg: "#0F2419",
    senderBg: "#0F2419",
    statusOnline: "#02BA54",
    statusEnding: "#ED645F",
    starActive: "#FFE200",
    starInactive: "#3a5a44",
    shadow: "rgba(0, 0, 0, 0.5)",
    hoverBg: "#143020",
    accent: "#2ECC71",
    appearance: "dark",
    chatMessageText: "#FFFFFF",
    chatAgentBubbleBg: "#153220",
    chatAgentBubbleBorder: "#245A38",
    chatUserGradientStart: "#27AE60",
    chatUserGradientEnd: "#1E8449",
    chatUserMessageText: "#FFFFFF",
    chatInputFieldBg: "#0A1A12",
    chatInputText: "#FFFFFF",
    chatInputPlaceholder: "#A8D5B8",
    chatMediaBg: "#0A1A12",
    chatIconColor: "#FFFFFF",
    chatLinkColor: "#58D68D",
  },
};
